"use client";

import { c as _c } from "react/compiler-runtime";
import type { Filter } from "../types/filter";
import { useFilterActions } from "./use-filter-actions";
import { useOptions } from "./use-options";
interface FilterProps {
  filterTypes: Filter[];
  sorting?: "alphabetically" | "count" | "custom";
}

/**
 * Manages filter actions and options in a single interface.
 *
 * @param props - Configuration options for the filter
 * @param props.filterTypes - Array of filter values to be processed
 * @param props.sorting - Optional sorting method for filter options
 *                     - 'alphabetically': Sort options in alphabetical order
 *                     - 'count': Sort options by their occurrence count
 *                     - 'custom': Use custom sorting order
 */
export const useFilter = props => {
  const $ = _c(3);
  const {
    filterTypes
  } = props;
  const actions = useFilterActions(filterTypes);
  const filterOptions = useOptions(props);
  let t0;
  if ($[0] !== actions || $[1] !== filterOptions) {
    t0 = {
      ...actions,
      ...filterOptions
    };
    $[0] = actions;
    $[1] = filterOptions;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};